var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"articulos-wrapper"},_vm._l((_vm.items),function(item){return _c('comparador-articulo',{key:`recuento-articulo-${item.id}`,attrs:{"item":item}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }